import React, { useEffect, useRef } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { Account, ComposeMail, ComposeMessage, getMailFormData, useSendEmailMutation } from "src/common";
import _ from "lodash";

type AllProps = {
    current_account: Account;
    show_mail: boolean;
    setShowMail: React.Dispatch<React.SetStateAction<boolean>>;
}

function MailModalSandbox(props: AllProps) {
    const { current_account, show_mail, setShowMail } = props;
    const [sendMail] = useSendEmailMutation();
    const counts_ref = useRef<number>(0);

    useEffect(() => {
        show_mail && console.log(" | ---------- | Begin Testing", counts_ref.current, " | ---------- | ");
    }, []);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        const recipients = form.recipients_tb.value.split(",");
        const subject = form.subject_tb.value.trim();
        const body = form.body_ta.value.trim();
        const totals = form.totals_tb.value;
        if (!!current_account) {
            counts_ref.current = 1;
            const _compose_mail = new ComposeMail("new", undefined, "", true);
            const _compose_message = new ComposeMessage(current_account, _compose_mail);
            _compose_message.tos = _.map(recipients, (_address) => {
                const address = _address.trim();
                return { address, name: address };
            });
            _sendMailForApp(_compose_message, subject, body, totals);
        } else {
            console.error("NO LOGGED IN ACCOUNT FOUND");
        }
    };

    // Description: Send mail for APP build mode
    function _sendMailForApp(
        _compose_message: ComposeMessage,
        default_subject: string = "[DEFAULT_SUBJECT]",
        default_body: string = "[DEFAULT BODY]",
        totals: number = 1) {
        const subject = `${default_subject} - ${counts_ref.current} out of ${totals}`;
        _compose_message.updateMessage(subject, default_body);
        const data = _compose_message.app_data;
        sendMail({
            senderId: "user@main.com",
            messageData: getMailFormData(data, _compose_message.attachments)
        }).unwrap()
            .then(() => {
                console.log("SUCCESS", counts_ref.current, totals);
                getNext(_compose_message, default_subject, default_body, totals);
            })
            .catch((error: unknown) => {
                console.error(error);
                setTimeout(() => {
                    getNext(_compose_message, default_subject, default_body, totals);
                }, 5000);

            });
    }
    function getNext(_compose_message: ComposeMessage,
        default_subject: string = "[DEFAULT_SUBJECT]",
        default_body: string = "[DEFAULT BODY]",
        totals: number = 1) {
        console.log("getNext", counts_ref.current, totals);
        counts_ref.current++;
        if (counts_ref.current <= totals) {
            _sendMailForApp(_compose_message, default_subject, default_body, totals);
        }
    }

    return <Modal size="lg" show={show_mail} onHide={() => setShowMail(false)}
        aria-labelledby="Mail Test Modal" centered>
        <Modal.Header closeButton>
            <Modal.Title>Mail Test Modal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form noValidate onSubmit={handleSubmit}>
                <Form.Group className="mb-3" >
                    <label>Recipients emails (string, comma separated, lowercase):</label>
                    <Form.Control
                        id="recipients_tb"
                        defaultValue="user1@main.com" // "user1@main.com, user2@main.com"
                        name="recipients_tb" autoComplete="off" />
                </Form.Group>
                <Form.Group className="mb-3">
                    <label>Email Subject:</label>
                    <Form.Control
                        id="subject_tb"
                        defaultValue="Testing email"
                        name="subject_tb" autoComplete="off" />
                </Form.Group>
                <Form.Group className="mb-3">
                    <label>Email Body:</label>
                    <Form.Control as="textarea" rows={10}
                        id="body_ta"
                        defaultValue={DefaultBody}
                        name="body_ta" autoComplete="off" />
                </Form.Group>
                <Form.Group className="mb-3">
                    <label>Number of copies to send out:</label>
                    <Form.Control
                        id="totals_tb"
                        type="number"
                        defaultValue={10}
                        name="totals_tb" autoComplete="off" />
                </Form.Group>
                <div className="btn-panel">
                    <Button type="submit">Send</Button>
                    <Button type="button" onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setShowMail(false);
                    }}>Close</Button>
                </div>
            </Form>
        </Modal.Body>
    </Modal>;
}

const DefaultBody = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus vel odio quis nulla suscipit iaculis vel eu lectus. Proin lacinia sollicitudin urna a ullamcorper. Quisque porttitor aliquet fringilla. Maecenas volutpat metus vel elementum pretium. Nulla eu pellentesque nibh. Quisque sed velit in libero egestas aliquam. Cras pretium porta urna a pretium. Nullam viverra finibus sapien, vel feugiat ipsum pretium ut. In faucibus ante eget orci mollis, eu ultrices nulla fringilla. Fusce dignissim pellentesque magna. Donec lectus massa, convallis et enim a, imperdiet fermentum neque. Pellentesque suscipit nunc ac felis malesuada, vel fermentum ante viverra.";

export default React.memo(MailModalSandbox);
